import { Dayjs } from 'dayjs';
import { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { TransactionType, TransactionStatus } from './transaction';
import { ValueOf, CommonFieldType } from './utils';
import { UserType } from './user';
import { ProductType } from './product';
import { BranchType } from './branch';

export type PositionFilters = {
  name: UserOption | null;
  type: TransactionType | 'all' | string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  status: TransactionStatus | 'all';
};
export type PositionFilterKey = keyof PositionFilters;
export type PositionFilterValue = ValueOf<PositionFilters>;

export type PositionTxType = CommonFieldType & {
  id: string;
  userId: string;
  type: TransactionType;
  status: TransactionStatus;
  userLevel: string;
  productId: string;
  amount: number;
  remainGoldAmount: number;
  pricePerUnit: number;
  priceDifferencePerUnit: number;
  unitName: string;
  currency: string;
  appointmentDate: string | null;
  paidAt: string | null;
  fee: number;
  total: number;
  createdBy: string;
  positionExpiredAt: string;
  isPartial: boolean;
  createdAt: string;
  updatedAt: string;
  user: UserType;
  product: ProductType;
  approvedByUser: UserType | null;
  note?: string;
  closePositionPricePerUnit?: number;
  paymentImageUrl?: string;
  paymentType?: UserTransactionPaymentType;
  branch?: BranchType;
  branchId: string;
  refTxIds: string[];
  refTxs: PositionTxType[] | null;
  stockCost: number;
  stockProfit: number;
  ticketNumber: string;
  ticketCreatedAt: string | null;

  // pdf
  paymentVoucherNo?: string;
  paymentVoucherUrl?: string;

  paymentReceiptNo?: string;
  paymentReceiptUrl?: string;

  depositReceiptNo?: string;
  depositReceiptUrl?: string;

  redeemReceiptNo?: string;
  redeemReceiptUrl?: string;

  priceUnit?: PriceUnit;
};

export enum UserTransactionPaymentType {
  BANK = 'BANK', // โอนเงิน
  CREDIT = 'CREDIT', // เครดิต (หักเงินในกระเป๋า)
  CASH = 'CASH', // เงินสด
}

export enum PriceUnit {
  PRICE_PER_KG = 'pricePerKg',
  PRICE_PER_BAHT = 'pricePerBaht',
  PRICE_PER_GRAM = 'pricePerGram',
}
